


// import React, { useState, useEffect } from 'react';
// import { createPortal } from 'react-dom';
// import '../styles/ManageDepartment.css';

// const ManageDepartment = () => {
//   const [departments, setDepartments] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [originalCodes, setOriginalCodes] = useState({});
//   const [pendingChange, setPendingChange] = useState(null);

//   const fetchDepartments = async () => {
//     try {
//       const response = await fetch('/gt-api/get_departments.php', {
//         credentials: "include"
//       });
//       const data = await response.json();
//       if (data.success) {
//         setDepartments(data.departments);
//         const codes = {};
//         data.departments.forEach(dept => {
//           codes[dept.id] = dept.DepartmentCode || "";
//         });
//         setOriginalCodes(codes);
//       }
//     } catch (err) {
//       console.error("Fetch Error:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchDepartments();
//   }, []);

//   const handleDelete = async (id) => {
//     if (window.confirm("Are you sure you want to delete this department?")) {
//       try {
//         const response = await fetch('/gt-api/delete_department.php', {
//           method: 'POST',
//           credentials: "include",
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ id })
//         });
//         const data = await response.json();
//         if (data.success) {
//           alert("Department deleted successfully");
//           fetchDepartments(); // Refresh list
//         } else {
//           alert("Error: " + data.message);
//         }
//       } catch (err) {
//         alert("Server error during deletion");
//       }
//     }
//   };

//   const handleCodeChange = (id, value) => {
//     setDepartments(prev =>
//       prev.map(dept =>
//         dept.id === id ? { ...dept, DepartmentCode: value } : dept
//       )
//     );
//   };

//   const revertToOriginal = (id) => {
//     setDepartments(prev =>
//       prev.map(dept =>
//         dept.id === id ? { ...dept, DepartmentCode: originalCodes[id] || "" } : dept
//       )
//     );
//   };

//   const updateDepartmentCode = async (id, DepartmentCode) => {
//     try {
//       console.log("Updating:", id, DepartmentCode); // 🔍 debug
//       const response = await fetch('/gt-api/get_departments.php', {
//         method: 'POST',
//         credentials: "include",
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify({
//           id: Number(id),
//           DepartmentCode: DepartmentCode.trim()
//         })
//       });

//       if (!response.ok) {
//         throw new Error(`HTTP error! Status: ${response.status}`);
//       }

//       const data = await response.json();
//       console.log("Update Response:", data);

//       if (data.success) {
//         // ✅ VERY IMPORTANT: sync UI with DB
//         fetchDepartments();
//       } else {
//         alert("Update failed: " + (data.message || "Unknown error"));
//         revertToOriginal(id);
//       }

//     } catch (err) {
//       console.error("Update Error:", err);
//       alert("Server error while updating. Check console.");
//       revertToOriginal(id);
//     }
//   };

//   const handleBlurOrSubmit = (id, deptName, value) => {
//     const trimmedVal = value.trim();
//     const originalVal = originalCodes[id] || "";
    
//     if (trimmedVal === originalVal) {
//       return;
//     }
    
//     setPendingChange({
//       id,
//       deptName,
//       oldCode: originalVal,
//       newCode: trimmedVal
//     });
//   };

//   const handleCancelUpdate = () => {
//     if (pendingChange) {
//       revertToOriginal(pendingChange.id);
//     }
//     setPendingChange(null);
//   };

//   const handleConfirmUpdate = async () => {
//     if (!pendingChange) return;
//     const { id, newCode } = pendingChange;
    
//     // Close modal first
//     setPendingChange(null);
//     await updateDepartmentCode(id, newCode);
//   };

//   useEffect(() => {
//     const handleKeyDown = (e) => {
//       if (e.key === 'Escape' && pendingChange) {
//         handleCancelUpdate();
//       }
//     };
//     window.addEventListener('keydown', handleKeyDown);
//     return () => window.removeEventListener('keydown', handleKeyDown);
//   }, [pendingChange, originalCodes]);

//   return (
//     <div className="module-glass-card animate-fade">
//       <div className="card-header-flex">
//         <div className="title-group">
//           <span className="pulse-icon">🏢</span>
//           <h3>DEPARTMENT_STRUCTURE</h3>
//         </div>
//       </div>

//       {/* Desktop Table */}
//       <div className="table-responsive-wrapper desktop-view">
//         <table className="cyber-table">
//           <thead>
//             <tr>
//               <th>DEPARTMENT_CODE</th>
//               <th>DEPARTMENT_NAME</th>
//               <th>CREATION_DATE</th>
//               <th>ACTIONS</th>
//             </tr>
//           </thead>

//           <tbody>
//             {loading ? (
//               <tr>
//                 <td colSpan="4" style={{ textAlign: "center" }}>
//                   SYNCING_DATA...
//                 </td>
//               </tr>
//             ) : (
//               departments.map((dept) => (
//                 <tr key={dept.id}>
//                   <td>
//                     <input
//                       type="text"
//                       value={dept.DepartmentCode || ""}
//                       onChange={(e) =>
//                         handleCodeChange(dept.id, e.target.value)
//                       }
//                       onBlur={(e) =>
//                         handleBlurOrSubmit(
//                           dept.id,
//                           dept.DepartmentName,
//                           e.target.value
//                         )
//                       }
//                       onKeyDown={(e) => {
//                         if (e.key === 'Enter') {
//                           e.target.blur();
//                         }
//                       }}
//                       className="dept-code-input"
//                     />
//                   </td>

//                   <td>{dept.DepartmentName}</td>

//                   <td>
//                     {dept.CreationDate
//                       ? new Date(
//                           dept.CreationDate
//                         ).toLocaleDateString("en-GB")
//                       : "N/A"}
//                   </td>

//                   <td className="action-buttons-cell">
//                     <button
//                       className="btn-action reject"
//                       onClick={() =>
//                         handleDelete(dept.id)
//                       }
//                     >
//                       DELETE
//                     </button>
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Mobile Cards */}
//       <div className="mobile-department-list">
//         {departments.map((dept) => (
//           <div
//             className="mobile-department-card"
//             key={dept.id}
//           >
//             <div className="mobile-department-title">
//               {dept.DepartmentName}
//             </div>

//             <div className="mobile-row">
//               <span>Code</span>

//               <input
//                 type="text"
//                 value={dept.DepartmentCode || ""}
//                 onChange={(e) =>
//                   handleCodeChange(
//                     dept.id,
//                     e.target.value
//                   )
//                 }
//                 onBlur={(e) =>
//                   handleBlurOrSubmit(
//                     dept.id,
//                     dept.DepartmentName,
//                     e.target.value
//                   )
//                 }
//                 onKeyDown={(e) => {
//                   if (e.key === 'Enter') {
//                     e.target.blur();
//                   }
//                 }}
//                 className="dept-code-input"
//               />
//             </div>

//             <div className="mobile-row">
//               <span>Created</span>
//               <span>
//                 {dept.CreationDate
//                   ? new Date(
//                       dept.CreationDate
//                     ).toLocaleDateString("en-GB")
//                   : "N/A"}
//               </span>
//             </div>

//             <button
//               className="btn-action reject mobile-delete-btn"
//               onClick={() =>
//                 handleDelete(dept.id)
//               }
//             >
//               DELETE
//             </button>
//           </div>
//         ))}
//       </div>

//       {/* Confirmation Modal Pop Up */}
//       {pendingChange && createPortal(
//         <div className="confirm-modal-overlay">
//           <div className="confirm-modal-content">
//             <div className="confirm-modal-title">Confirm Save</div>
//             <p className="confirm-modal-text">
//               Do you want to save the department code change for <br />
//               <span className="confirm-modal-highlight">{pendingChange.deptName}</span>?<br />
//               <br />
//               Code will change from <span className="confirm-modal-highlight">{pendingChange.oldCode || "empty"}</span> to <span className="confirm-modal-highlight">{pendingChange.newCode}</span>.
//             </p>
//             <div className="confirm-modal-buttons">
//               <button 
//                 className="confirm-btn confirm-btn-yes" 
//                 onClick={handleConfirmUpdate}
//               >
//                 Yes, Save
//               </button>
//               <button 
//                 className="confirm-btn confirm-btn-no" 
//                 onClick={handleCancelUpdate}
//               >
//                 No, Cancel
//               </button>
//             </div>
//           </div>
//         </div>,
//         document.body
//       )}
//     </div>
//   );
// };

// export default ManageDepartment;



































import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import '../styles/ManageDepartment.css';

const ManageDepartment = () => {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [originalCodes, setOriginalCodes] = useState({});
  const [originalNames, setOriginalNames] = useState({});
  const [pendingChange, setPendingChange] = useState(null);

  const codeInputRefs = useRef({});
  const nameInputRefs = useRef({});

  const fetchDepartments = async () => {
    try {
      const response = await fetch('/gt-api/get_departments.php', {
        credentials: "include"
      });
      const data = await response.json();
      if (data.success) {
        setDepartments(data.departments);
        const codes = {};
        const names = {};
        data.departments.forEach(dept => {
          codes[dept.id] = dept.DepartmentCode || "";
          names[dept.id] = dept.DepartmentName || "";
        });
        setOriginalCodes(codes);
        setOriginalNames(names);
      }
    } catch (err) {
      console.error("Fetch Error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDepartments();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this department?")) {
      try {
        const response = await fetch('/gt-api/delete_department.php', {
          method: 'POST',
          credentials: "include",
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id })
        });
        const data = await response.json();
        if (data.success) {
          alert("Department deleted successfully");
          fetchDepartments(); // Refresh list
        } else {
          alert("Error: " + data.message);
        }
      } catch (err) {
        alert("Server error during deletion");
      }
    }
  };

  const handleCodeChange = (id, value) => {
    setDepartments(prev =>
      prev.map(dept =>
        dept.id === id ? { ...dept, DepartmentCode: value } : dept
      )
    );
  };

  const handleNameChange = (id, value) => {
    setDepartments(prev =>
      prev.map(dept =>
        dept.id === id ? { ...dept, DepartmentName: value } : dept
      )
    );
  };

  const revertToOriginal = (id) => {
    setDepartments(prev =>
      prev.map(dept =>
        dept.id === id
          ? {
            ...dept,
            DepartmentCode: originalCodes[id] || "",
            DepartmentName: originalNames[id] || ""
          }
          : dept
      )
    );
  };

  const updateDepartment = async (id, DepartmentCode, DepartmentName) => {
    try {
      console.log("Updating Dept:", id, DepartmentCode, DepartmentName);
      const response = await fetch('/gt-api/get_departments.php', {
        method: 'POST',
        credentials: "include",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: Number(id),
          DepartmentCode: DepartmentCode.trim(),
          DepartmentName: DepartmentName.trim()
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Update Response:", data);

      if (data.success) {
        fetchDepartments();
      } else {
        alert("Update failed: " + (data.message || "Unknown error"));
        revertToOriginal(id);
      }
    } catch (err) {
      console.error("Update Error:", err);
      alert("Server error while updating. Check console.");
      revertToOriginal(id);
    }
  };

  const handleBlurOrSubmit = (id) => {
    const dept = departments.find(d => d.id === id);
    if (!dept) return;

    const trimmedCode = (dept.DepartmentCode || "").trim();
    const trimmedName = (dept.DepartmentName || "").trim();
    const originalCode = originalCodes[id] || "";
    const originalName = originalNames[id] || "";

    if (trimmedCode === originalCode && trimmedName === originalName) {
      return;
    }

    if (!trimmedName) {
      alert("Department Name cannot be empty.");
      revertToOriginal(id);
      return;
    }

    setPendingChange({
      id,
      oldCode: originalCode,
      newCode: trimmedCode,
      oldName: originalName,
      newName: trimmedName
    });
  };

  const handleCancelUpdate = () => {
    if (pendingChange) {
      revertToOriginal(pendingChange.id);
    }
    setPendingChange(null);
  };

  const handleConfirmUpdate = async () => {
    if (!pendingChange) return;
    const { id, newCode, newName } = pendingChange;

    setPendingChange(null);
    await updateDepartment(id, newCode, newName);
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && pendingChange) {
        handleCancelUpdate();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [pendingChange, originalCodes, originalNames]);

  return (
    <div className="module-glass-card animate-fade">
      <div className="card-header-flex">
        <div className="title-group">
          <span className="pulse-icon">🏢</span>
          <h3>DEPARTMENT_STRUCTURE</h3>
        </div>
      </div>

      {/* Desktop Table */}
      <div className="table-responsive-wrapper desktop-view">
        <table className="cyber-table">
          <thead>
            <tr>
              <th>DEPARTMENT_CODE</th>
              <th>DEPARTMENT_NAME</th>
              <th>CREATION_DATE</th>
              <th>ACTIONS</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="4" style={{ textAlign: "center" }}>
                  SYNCING_DATA...
                </td>
              </tr>
            ) : (
              departments.map((dept) => (
                <tr key={dept.id}>
                  <td>
                    <div className="editable-cell-wrapper">
                      <input
                        type="text"
                        ref={el => codeInputRefs.current[dept.id] = el}
                        value={dept.DepartmentCode || ""}
                        onChange={(e) =>
                          handleCodeChange(dept.id, e.target.value)
                        }
                        onBlur={() => handleBlurOrSubmit(dept.id)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            e.target.blur();
                          }
                        }}
                        className="dept-code-input"
                        placeholder="Code"
                      />
                      <button
                        type="button"
                        className="edit-pencil-btn"
                        onClick={() => {
                          const el = codeInputRefs.current[dept.id];
                          if (el) {
                            el.focus();
                            el.select();
                          }
                        }}
                        title="Edit Department Code"
                      >
                        ✏️
                      </button>
                    </div>
                  </td>

                  <td>
                    <div className="editable-cell-wrapper">
                      <input
                        type="text"
                        ref={el => nameInputRefs.current[dept.id] = el}
                        value={dept.DepartmentName || ""}
                        onChange={(e) =>
                          handleNameChange(dept.id, e.target.value)
                        }
                        onBlur={() => handleBlurOrSubmit(dept.id)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            e.target.blur();
                          }
                        }}
                        className="dept-name-input"
                        placeholder="Department Name"
                      />
                      <button
                        type="button"
                        className="edit-pencil-btn"
                        onClick={() => {
                          const el = nameInputRefs.current[dept.id];
                          if (el) {
                            el.focus();
                            el.select();
                          }
                        }}
                        title="Edit Department Name"
                      >
                        ✏️
                      </button>
                    </div>
                  </td>

                  <td>
                    {dept.CreationDate
                      ? new Date(
                        dept.CreationDate
                      ).toLocaleDateString("en-GB")
                      : "N/A"}
                  </td>

                  <td className="action-buttons-cell">
                    <button
                      className="btn-action reject"
                      onClick={() =>
                        handleDelete(dept.id)
                      }
                    >
                      DELETE
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Mobile Cards */}
      <div className="mobile-department-list">
        {departments.map((dept) => (
          <div
            className="mobile-department-card"
            key={dept.id}
          >
            <div className="mobile-department-title">
              <input
                type="text"
                value={dept.DepartmentName || ""}
                onChange={(e) =>
                  handleNameChange(dept.id, e.target.value)
                }
                onBlur={() => handleBlurOrSubmit(dept.id)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.target.blur();
                  }
                }}
                className="dept-name-input"
              />
            </div>

            <div className="mobile-row">
              <span>Code</span>

              <input
                type="text"
                value={dept.DepartmentCode || ""}
                onChange={(e) =>
                  handleCodeChange(
                    dept.id,
                    e.target.value
                  )
                }
                onBlur={() => handleBlurOrSubmit(dept.id)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.target.blur();
                  }
                }}
                className="dept-code-input"
              />
            </div>

            <div className="mobile-row">
              <span>Created</span>
              <span>
                {dept.CreationDate
                  ? new Date(
                    dept.CreationDate
                  ).toLocaleDateString("en-GB")
                  : "N/A"}
              </span>
            </div>

            <button
              className="btn-action reject mobile-delete-btn"
              onClick={() =>
                handleDelete(dept.id)
              }
            >
              DELETE
            </button>
          </div>
        ))}
      </div>

      {/* Confirmation Modal Pop Up */}
      {pendingChange && createPortal(
        <div className="confirm-modal-overlay">
          <div className="confirm-modal-content">
            <div className="confirm-modal-title">Confirm Save</div>
            <div className="confirm-modal-text">
              Do you want to save changes for department <br />
              <strong className="confirm-modal-highlight">{pendingChange.oldName}</strong>?<br />
              <br />
              {pendingChange.newCode !== pendingChange.oldCode && (
                <div style={{ marginBottom: "4px" }}>
                  Code: <span className="confirm-modal-highlight">{pendingChange.oldCode || "empty"}</span> → <span className="confirm-modal-highlight">{pendingChange.newCode}</span>
                </div>
              )}
              {pendingChange.newName !== pendingChange.oldName && (
                <div>
                  Name: <span className="confirm-modal-highlight">{pendingChange.oldName}</span> → <span className="confirm-modal-highlight">{pendingChange.newName}</span>
                </div>
              )}
            </div>
            <div className="confirm-modal-buttons">
              <button
                className="confirm-btn confirm-btn-yes"
                onClick={handleConfirmUpdate}
              >
                Yes, Save
              </button>
              <button
                className="confirm-btn confirm-btn-no"
                onClick={handleCancelUpdate}
              >
                No, Cancel
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}
    </div>
  );
};

export default ManageDepartment;